import _ from 'lodash';

const getNormalizedLength = (markdown) => {
  if (!markdown) {
    return 0;
  }

  const trimmed = markdown.trim();

  const mathMatches = /^\$(.*)\$$/.exec(trimmed);
  if (!mathMatches) {
    const words = trimmed.split(' ');
    const longestWord = _.maxBy(words, 'length').length;
    const totalLength = trimmed.length;

    return Math.max(longestWord, totalLength / 3);
  }

  const [, math] = mathMatches;

  let working = math;
  working = working.replace(/\\frac{(.*?)}/g, '|$1');
  working = working.replace(/\\sqrt{(.*?)}/g, '|$1');

  return working.length;
};

export default getNormalizedLength;
